import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

export class Captcha extends Component {
  constructor(props) {
    super(props);
    this.state = {
      success: false,
    };
  }

  onSuccess(key) {
    this.setState({ success: true, key });
    if (this.props.onSuccess) {
      this.props.onSuccess(key);
    }
  }

  render() {
    // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { props, state } = this;
    const recaptchaProps = {
      sitekey: props.sitekey || window.$recaptcha_key || null,
      onChange: this.onSuccess.bind(this),
    };

    if (!window || !recaptchaProps.sitekey) {
      return <div>loading...</div>;
    }

    return <ReCAPTCHA {...recaptchaProps} />;
  }
}

Captcha.propTypes = {
  sitekey: PropTypes.string,
  onSuccess: PropTypes.func,
};

export default Captcha;
